export interface PowermeterHistory {
  time: number
  NetIn: number
  NetOut: number
  type: PowermeterType[]
}

export type PowermeterType = 'production' | 'consumption' | 'alien' | 'bypass' | 'bypassNoCharge' | 'farmzcounter' | 'enera' | 'hvac'

export const powermeterTypeMapping: Record<number, PowermeterType[] | undefined> = {
  //1: ROOT
  2: ['production'],
  3: ['production', 'consumption'],
  4: ['consumption'],
  9: ['alien'],
  10: ['bypass'],
  11: ['bypassNoCharge'],
  13: ['hvac', 'consumption'],
  105: ['farmzcounter'],
  200: ['enera'],
}

export function isConsumption(type: PowermeterType[] | undefined): boolean {
  return !!type?.includes('consumption')
}

export function isProduction(type: PowermeterType[] | undefined): boolean {
  return !!type?.includes('production')
}

export function isBypass(type: PowermeterType[] | undefined): boolean {
  return !!type?.includes('bypass')
}

export function isBypassNoCharge(type: PowermeterType[] | undefined): boolean {
  return !!type?.includes('bypassNoCharge')
}

export function isEnera(type: PowermeterType[] | undefined): boolean {
  return !!type?.includes('enera')
}

export function isHvac(type: PowermeterType[] | undefined): boolean {
  return !!type?.includes('hvac')
}
